import { createVanIconComponent } from "./van"

const BrowsingHistoryOutlined = createVanIconComponent("browsing-history-o")
export default BrowsingHistoryOutlined
